export const booleanFormatter = {
    asDisplayValue: (value: unknown): string => value == null ? '' : value.toString(),
    asFilterValue: (value: unknown): string => value == null ? '' : value.toString(),
};
